export default {
  'supply-get-list': {
    method: 'post',
    url: '/client/supply/list'
  },
  supplyCreate: {
    method: 'post',
    url: '/client/supply'
  },
  supplyUpdate: {
    method: 'put',
    url: '/client/supply'
  },
  supplyDelete: {
    method: 'delete',
    url: '/client/supply'
  }
}
